const { handleError, handleResponse, api } = require("./baseApi");
const api_config = require("./api_config");

const EXTEND_URL = "/subscriptions/v1";

function getPlansApi(location, merchantCode, basketCode) {
  const basketCodeUrlParam = basketCode && basketCode.trim().length > 0 ? `&basketCode=${basketCode}` : '';
  return api
    .get(`${EXTEND_URL}/plans` + (location ? `?country=${location}&merchantCode=${merchantCode}${basketCodeUrlParam}` : ""), {
      headers: { "x-api-key": `${api_config.carbon_app_api_key}` }
    })
    .then(handleResponse)
    .catch(handleError);
}

function getGroupPlansApi(country, merchantCode) {
  return api
    .get(`${EXTEND_URL}/group/plans`, {
      headers: { "x-api-key": `${api_config.carbon_app_api_key}` },
      params: {country,merchantCode}
    })
    .then(handleResponse)
    .catch(handleError);
}

module.exports = { getPlansApi, getGroupPlansApi };
